module.exports = __webpack_public_path__ + "img/work1.a9691a7f.gif";